module.exports = __webpack_public_path__ + "img/hz4.0cde5936.png";